import type { PageMeta } from '../../../lib/permissions/pageMeta'
import SalesPage from '../../sales/SalesPage'

export const pageMeta: PageMeta = {
  key: 'sell.invoices',
  label: 'Invoices',
  module: 'Trading',
  section: 'Sell',
  description: 'List & manage sales invoices',
  defaultPermissions: {
    owner: 'edit', admin: 'edit', manager: 'edit',
    accountant: 'view', cashier: 'view', viewer: 'view',
  },
  hasVisibility: true,
  ownerColumn: 'created_by',
}

export default function SellInvoicesTab() {
  return <SalesPage />
}
